import(/* webpackMode: "eager" */ "/home/runner/work/devpath-ai/devpath-ai/app/favorites/page.tsx");
